import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

import { authManager } from "../global";

const webSocketProtocol = window.location.protocol === "https:" ? "wss" : "ws";

const wsUrl = `${webSocketProtocol}://${window.location.host}/subscribe`;

export const wsLink = new GraphQLWsLink(
    createClient({
        url: wsUrl,
        lazy: true,
        connectionParams: () => {
            return {
                Authorization: authManager.authHeader,
            };
        },
    })
);
